import { createContext, useContext, useState, useCallback, useEffect } from "react";
import { translations } from "./translations";

const LanguageContext = createContext(null);

const getInitial = () => {
  try {
    const saved = localStorage.getItem("mgd_lang");
    if (saved === "en" || saved === "es") return saved;
  } catch { /* ignore */ }
  return "en";
};

function lookup(obj, path) {
  return path.split(".").reduce((acc, k) => (acc == null ? undefined : acc[k]), obj);
}

function interpolate(str, vars) {
  return str.replace(/\{(\w+)\}/g, (m, k) => (vars[k] != null ? vars[k] : m));
}

export function LanguageProvider({ children }) {
  const [lang, setLangState] = useState(getInitial);

  useEffect(() => {
    document.documentElement.lang = lang;
  }, [lang]);

  const setLang = useCallback((l) => {
    setLangState(l);
    try { localStorage.setItem("mgd_lang", l); } catch { /* ignore */ }
  }, []);

  const toggleLang = useCallback(() => {
    setLang(lang === "en" ? "es" : "en");
  }, [lang, setLang]);

  const t = useCallback((key, vars) => {
    let val = lookup(translations[lang], key);
    if (val === undefined) val = lookup(translations.en, key);
    if (val === undefined) return key;
    if (typeof val === "string" && vars) return interpolate(val, vars);
    return val;
  }, [lang]);

  return (
    <LanguageContext.Provider value={{ lang, setLang, toggleLang, t }}>
      {children}
    </LanguageContext.Provider>
  );
}

export const useLang = () => useContext(LanguageContext);
